import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {FormItemConfigurationModel} from '../../../../models/forms/form-item-configuration.model';
import {FormItemDataModel} from '../../../../models/forms/data/form-item-data.model';
import {PatientCaseWorkItemFormDataModel} from '../../../../models/forms/data/patient-case-work-item-form-data.model';
import {FormParagraphDataModel} from '../../../../models/forms/data/form-paragraph-data.model';
import {FormParagraphConfigurationModel} from '../../../../models/forms/form-paragraph-configuration.model';
import {FormVersionConfigurationModel} from '../../../../models/forms/form-version-configuration.model';

@Component({
  selector: 'app-forms-builder-polished-preview',
  templateUrl: './forms-builder-polished-preview.component.html',
  styleUrls: ['./forms-builder-polished-preview.component.css']
})
export class FormsBuilderPolishedPreviewComponent implements OnInit {

  cfgFormVersion: FormVersionConfigurationModel;
  dataForm: PatientCaseWorkItemFormDataModel;
  isLoading: boolean = false;
  colorGuides: boolean = false;
  mobilePreview: boolean = false;
  refreshingView: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<FormsBuilderPolishedPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.cfgFormVersion = JSON.parse(JSON.stringify(this.data.cfgFormVersion));
    this.filterOutAllDeletedObjects();
  }

  filterOutAllDeletedObjects() {
    this.cfgFormVersion.cfgDFormParagraphs = this.cfgFormVersion.cfgDFormParagraphs.filter(paragraph => {
      return paragraph.xauditDeleted == false;
    });

    this.cfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      paragraph.cfgDFormItems = paragraph.cfgDFormItems.filter(item => {
        return item.xauditDeleted == false;
      });
    });
  }

  close() {
    this.dialogRef.close();
  }

  populateSpoofData() {
    let promise = new Promise((resolve, reject) => {
      let dataForm = new PatientCaseWorkItemFormDataModel();

      dataForm.DFormId = this.cfgFormVersion.DFormId;
      dataForm.formOrder = 0;
      dataForm.dataFormParagraphs = [];
      let promises = [];
      this.cfgFormVersion.cfgDFormParagraphs.map((paragraph, i) => {
        promises.push(this.populateParagraph(paragraph, i));
      });
      Promise.all(promises).then((results: FormParagraphDataModel[]) => {
        dataForm.dataFormParagraphs = results;
        resolve(dataForm);
      });
    });
    return promise;
  }

  populateParagraph(paragraph: FormParagraphConfigurationModel, index: number) {
    let promise = new Promise((resolve, reject) => {
      let dataParagraph = new FormParagraphDataModel();
      dataParagraph.dataFormParagraphID = `${index}`;
      dataParagraph.DFormParagraphId = paragraph.DFormParagraphId;
      dataParagraph.ParagraphOrder = paragraph.ParagraphOrder;
      dataParagraph.cfgDFormParagraph = JSON.parse(JSON.stringify(paragraph));
      dataParagraph.dataFormItems = [];
      let promises = [];
      paragraph.cfgDFormItems.forEach((item, i) => {
        promises.push(this.populateItem(item, JSON.parse(JSON.stringify(dataParagraph)), i));
      });

      Promise.all(promises).then((results: FormItemDataModel[]) => {
        dataParagraph.dataFormItems = results;
        resolve(dataParagraph);
      });
    });
    return promise;
  }

  populateItem(item: FormItemConfigurationModel, paragraph: FormParagraphDataModel, index: number) {
    let promise = new Promise((resolve, reject) => {
      let dataItem = new FormItemDataModel();
      dataItem.dataFormItemId = `${index}`;
      dataItem.dataFormParagraphID = paragraph.dataFormParagraphID;
      dataItem.ItemName = item.DFormItemName;
      dataItem.DFormItemId = item.DFormItemId;
      dataItem.HasChildren = item.HasChildren;
      dataItem.ParentdataFormItemId = item.ParentDFormItemId;
      dataItem.cfgDFormItem = JSON.parse(JSON.stringify(item));
      dataItem.dataFormResults = [];
      resolve(dataItem);
    });
    return promise;
  }

  resetView() {
    this.refreshingView = true;
    setTimeout(_ => {
      this.refreshingView = false;
    }, 500);
  }

}
